
export default {
  name: 'HomeBrandsBanner',
  props: {
    brands: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    duplicatedBrands() {
      if (this.brands.length < 8) return this.brands
      return [...this.brands, ...this.brands]
    },
  },
  methods: {
    brandUrl(brand) {
      return this.localePath({
        name: 'marques-vehicules-slug',
        params: { slug: brand.slug },
      })
    },
  },
}
